import * as React from 'react';
import { useIntl } from 'react-intl';

import { cornerRadiusS, scale110 } from '@xing-com/tokens';

import { SkeletonRectangle } from '../';
import type { SkeletonCheckboxProps } from '../';

export const SkeletonCheckbox = React.forwardRef<
  HTMLDivElement,
  SkeletonCheckboxProps
>(({ className, ...props }, forwardedRef): JSX.Element => {
  const intl = useIntl();

  return (
    <SkeletonRectangle
      aria-busy="true"
      aria-label={intl.formatMessage({
        id: 'XDS_SKELETON_GENERIC_A11Y',
        defaultMessage: 'Loading',
      })}
      className={className}
      cornerRadius={cornerRadiusS}
      data-xds="SkeletonCheckbox"
      ref={forwardedRef}
      role="status"
      size={scale110}
      {...props}
    />
  );
});

SkeletonCheckbox.displayName = 'SkeletonCheckbox';
